import { makeActionCreatorV2 } from '../../actions';

import { moduleId } from './config';

export const updateEmail = makeActionCreatorV2('UPDATE_EMAIL', { email: 'email' }, moduleId);
